import { useGlobalShortcutsData } from '@atlassian/global-shortcuts';

import type { ShortcutsConfig } from '../../../common/types';
import { useOptions } from '../../options-provider';

export const useHydratedShortcuts = (rawShortcuts: ShortcutsConfig | undefined) => {
	const { cloudId, orgId, isShortcutsStatic } = useOptions();

	return useGlobalShortcutsData({
		shortcutsConfig: rawShortcuts,
		cloudId,
		orgId,
		isShortcutsStatic,
	});
};
